import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const list = (merchantId, branchId, filters, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/reservations`, {
		branchId,
		pageNum: page,
		pageSize,
		...filters,
	});
};

const diagram = (merchantId, branchId, filters) => {
	return Client.get(`${baseUrl}/${merchantId}/reservations-diagram`, {
		branchId,
		...filters,
	});
};

const exportReport = (merchantId, branchId, filters) => {
	return Client.get(
		`${baseUrl}/${merchantId}/reservations/report/export`,
		{
			branchId,
			...filters,
		},
		{
			responseType: 'blob',
		}
	);
};

const listArea = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/areas`, {
		branchId,
	});
};

const listTableSet = (merchantId, branchId, areaId) => {
	return Client.get(`${baseUrl}/${merchantId}/tableSets/picture`, {
		branchId,
		areaId,
	});
};

const listTableSetPage = (merchantId, branchId, conditions) => {
	return Client.get(`${baseUrl}/${merchantId}/tableSets`, {
		branchId,
		...conditions,
	});
};

const updateTableSet = (merchantId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/tableSets/${id}`, data);
};

const deleteTableSet = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/tableSets/${id}`, payload);
};

const checkComination = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/tableSets/combinationCheck`,
		payload
	);
};

const createCombination = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/tableSets/combinationTables`,
		payload
	);
};

const settings = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/reservationSettings`, {
		branchId,
	});
};

const createSettings = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/reservationSettings`, payload);
};

const updateSettings = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/reservationSettings/${id}`,
		payload
	);
};

const mealTimeSettings = (merchantId, branchId, weekDay) => {
	return Client.get(`${baseUrl}/${merchantId}/mealTimeSettings`, {
		branchId,
		weekDay,
	});
};

const validMealTime = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/valid-meal-time`, data);
};

const createMealTime = (
	merchantId,
	branchId,
	weekDay,
	kind,
	priorityType,
	start,
	end,
	limitPersons,
	available,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/mealTimeSettings`, {
		branchId,
		weekDay,
		start,
		end,
		kind,
		limitPersons,
		priorityType,
		available,
		operateBy,
	});
};

const updateMealTime = (
	merchantId,
	branchId,
	id,
	weekDay,
	kind,
	priorityType,
	start,
	end,
	limitPersons,
	available,
	operateBy
) => {
	return Client.put(`${baseUrl}/${merchantId}/mealTimeSettings/${id}`, {
		branchId,
		weekDay,
		start,
		end,
		kind,
		limitPersons,
		priorityType,
		available,
		operateBy,
	});
};

const removeMealTime = (merchantId, branchId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/mealTimeSettings/${id}`, {
		branchId,
		operateBy,
	});
};

const closedDaySettings = (merchantId, branchId, busType) => {
	return Client.get(`${baseUrl}/${merchantId}/tempBusTimes`, {
		branchId,
		busType,
	});
};

const createClosedDay = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/tempBusTimes`, data);
};

const updateClosedDay = (merchantId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/tempBusTimes/${id}`, data);
};

const removeClosedDay = (merchantId, branchId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/tempBusTimes/${id}`, {
		branchId,
		operateBy,
	});
};

const kpiSummary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/reservations/kpi-summary`, data);
};

const batchModifyTablesets = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/tableSets/batch-modify`, data);
};

const guestReservation = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/guests/reservations`, data);
};

export default {
	list,
	diagram,
	exportReport,
	listTableSet,
	listArea,
	listTableSetPage,
	updateTableSet,
	deleteTableSet,
	checkComination,
	createCombination,
	settings,
	createSettings,
	updateSettings,
	mealTimeSettings,
	validMealTime,
	createMealTime,
	updateMealTime,
	removeMealTime,
	closedDaySettings,
	createClosedDay,
	updateClosedDay,
	removeClosedDay,
	kpiSummary,
	batchModifyTablesets,
	guestReservation,
};
